import { SectionCard, SectionCardTitle } from "@/components";
import ProductsImageGrid from "./ImageGrid";
import { ProductDetails } from "./ProductsDetails";
import { Meta } from "@/components";


const OurProducts = () => {
  return (
    <>
    <Meta
      title="Intron - Our Products"
  />
    {/* <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-1/2 w-full lg:mt-20">
          <SectionCardTitle>Our Solutions</SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px]     text-[#415667] mt-4">
            Discover our diverse range of science-driven probiotic and biotech solutions for aquaculture, poultry, shrimp, fish, ruminants, and more.
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <ProductsImageGrid />
        </div>
        </div>

      </div>
    </SectionCard> */}
    <ProductDetails />
  </>
  );
};

export default OurProducts;
